import script from "./ClothingTimelineLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ClothingTimelineLayout.vue?vue&type=script&setup=true&lang=js"

import "./ClothingTimelineLayout.vue?vue&type=style&index=0&id=116ec34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116ec34c"]])

export default __exports__